import axios from 'axios';

export async function getUserAsync(id) {
  const url = `${process.env.REACT_APP_HOST_URL}user/${id}`;
  const response = await axios.get(url);
  return response;
}

export async function updateUserAsync(userId, payload) {
  const url = `${process.env.REACT_APP_HOST_URL}user/${userId}`;
  const response = await axios.put(url, payload);
  return response;
}

export async function changePasswordAsync(payload) {
  const url = `${process.env.REACT_APP_HOST_URL}user/changepassword`;
  const response = await axios.patch(url, payload);
  return response;
}

export async function getUserProfileGeneralDataAsync() {
  const url = `${process.env.REACT_APP_HOST_URL}user/profile/general-data`;
  const response = await axios.get(url);
  return response;
}

export async function updateUserProfileGeneralDataAsync(payload) {
  const url = `${process.env.REACT_APP_HOST_URL}user/profile/general-data`;
  const response = await axios.put(url, payload);
  return response;
}
